export const BeatStateEnum = {
	OFF: 0,
	ON: 1,
	ACCENT: 2,
}
